<ng-container *transloco="let t; read: 'date-range-picker'">

  <div class="bg-card mat-elevation-z2 border shadow-md overflow-y-auto space-y-4" [formGroup]="form">
    <div class="p-4 flex flex-col space-y-4">
      <div class="flex flex-col space-y-4">
        <span class="font-bold">{{t('LABEL')}}</span>
        <mat-button-toggle-group formControlName="period" (change)="selectPeriod($event)">
          <mat-button-toggle *ngFor="let period of availablePeriods"
                             [value]="period">{{t('PERIOD_' + period)}}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      
      <ng-container *ngIf="selectedRangeValue">
      <ng-container [ngSwitch]="period | async">
        <ng-container *ngSwitchCase="1">
          <mat-calendar [selected]="selectedRangeValue" (selectedChange)="selectedChange($event)"></mat-calendar>
        </ng-container>
        <ng-container *ngSwitchCase="2">
          <mat-calendar [selected]="selectedRangeValue" (selectedChange)="selectedChange($event)"></mat-calendar>
        </ng-container>
        <ng-container *ngSwitchCase="3">
          <mat-calendar [selected]="selectedRangeValue" startView="year" (monthSelected)="monthSelected($event)"
                        (selectedChange)="selectedChange($event)"></mat-calendar>
        </ng-container>
        <ng-container *ngSwitchCase="4">
          <mat-calendar [selected]="selectedRangeValue" startView="multi-year" (yearSelected)="yearSelected($event)"
                        (selectedChange)="selectedChange($event)"></mat-calendar>
        </ng-container>
        <ng-container *ngSwitchCase="5">
          <mat-calendar [selected]="selectedRangeValue" (selectedChange)="selectedChange($event)"></mat-calendar>
        </ng-container>
      </ng-container>
      </ng-container>

    </div>

    <div class="flex flex-auto justify-between p-2">
      <button mat-button (click)="close()">
        <span>{{ t('ACTION_CANCEL') }}</span>
      </button>
      <button mat-button color="primary" (click)="save()">
        <span>{{ t('ACTION_APPLY') }}</span>
      </button>
    </div>

  </div>

</ng-container>
